export default __webpack_public_path__ + "static/media/Ellipse 24 (3).2931968e.png";